module.exports = __webpack_public_path__ + "img/talent-reason-3.d8e41f52.png";